/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { Box, Grid, styled, Tab, Tabs } from "@mui/material";
import Card from "../../components/Cards/Card";
import { useQlik } from "../../context/Qlik";
import NativeObject from "../../components/NativeObject/NativeObject";

const LayoutCardsWrapper = styled("div")({
	alignItems: "center",
	display: "flex",
	flexDirection: "column",
	height: "100%",
	justifyContent: "start",
	width: "100%",
});

const LayoutCardWrapper = styled("div")({
	borderRadius: "16px",
	display: "flex",
	width: "100%",
	paddingRight: "10px",
});

function DetailDesktop({ app, config }) {
	const notFullHd = useMediaQuery({ query: "(max-width: 1366px)" });
	const [filterUpdate, sendFilterUpdate] = useState(0);
	const { setSwitchOnDemand } = useQlik();

	const [alignment, setAlignment] = useState("Sell Out");

	const initializeField = () => {
		app.field("%Selecao").selectMatch("Sell Out");
	};

	useEffect(() => {
		if (app) {
			initializeField();
		}
	}, []);

	const tabList = ["Sell Out", "Sell In", "Positivação"];

	const handleChange = (event, newAlignment) => {
		app.field("%Selecao").selectMatch(tabList[newAlignment]);
		setAlignment(tabList[newAlignment]);
		sendFilterUpdate(newAlignment);
	};

	useEffect(() => {
		setSwitchOnDemand(false);
	}, []);

	return (
		<div className="app detail">
			<div className="appContent appContentOverflow">
				<LayoutCardsWrapper>
					<LayoutCardWrapper>
						<Grid
							className="title-wrapper"
							container
							direction="row"
							justifyContent={"space-between"}
							alignItems={"center"}
						>
							<h1 className="title">Detalhe</h1>

							<Box
								className="toggle"
								style={{
									margin: "0px 2px 4px",
									paddingBottom: "8px",
								}}
								color="primary"
								sx={{}}
							>
								<Tabs
									value={filterUpdate}
									onChange={handleChange}
									aria-label="basic tabs example"
									style={{
										marginTop: "0px",
										paddingTop: "0px",
										textAlign: "center",
									}}
								>
									<Tab
										label={
											<span className="toggle-button">
												Sell Out
											</span>
										}
									/>
									<Tab
										label={
											<span className="toggle-button">
												Sell In
											</span>
										}
									/>
									<Tab
										label={
											<span className="toggle-button">
												Positivação
											</span>
										}
									/>
								</Tabs>
							</Box>
						</Grid>{" "}
					</LayoutCardWrapper>
					{/* DETAILS TABLE */}
					<LayoutCardWrapper
						style={{ height: notFullHd ? "86vh" : "80vh" }}
					>
						<Card
							app={app}
							exportTable
							exportTableId="ZJHDcbg"
							header={{
								hardTitle: alignment,
							}}
							style={{ width: "100%" }}
						>
							<NativeObject
								app={app}
								key="ZJHDcbg"
								reference={{ id: "ZJHDcbg" }}
							/>
						</Card>
					</LayoutCardWrapper>
				</LayoutCardsWrapper>
			</div>
		</div>
	);
}

DetailDesktop.defaultProps = {
	app: null,
	config: {},
};

DetailDesktop.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default DetailDesktop;
